var _desc, _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 60,
    viewBox: "0 0 48 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n\t\t\tCreated with Pixso.\n\t")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path",
    d: "M6 60C4.35 60 2.93 59.41 1.76 58.23C0.58 57.06 0 55.64 0 54L0 18L18 0L42 0C43.64 0 45.06 0.58 46.23 1.76C47.41 2.93 48 4.35 48 6L48 54C48 55.64 47.41 57.06 46.23 58.23C45.06 59.41 43.64 60 42 60L6 60ZM6 54L42 54L42 6L20.54 6L6 20.55L6 54ZM24 45C24.85 45 25.56 44.71 26.13 44.13C26.71 43.56 27 42.85 27 42C27 41.14 26.71 40.43 26.13 39.86C25.56 39.28 24.85 39 24 39C23.14 39 22.43 39.28 21.86 39.86C21.28 40.43 21 41.14 21 42C21 42.85 21.28 43.56 21.86 44.13C22.43 44.71 23.14 45 24 45ZM21 33L27 33L27 18L21 18L21 33ZM6 54L42 54L6 54Z",
    fill: "#FFFFFF",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound);
export default __webpack_public_path__ + "static/media/notFound.808b3fb2d7754b771431a34a0f9306f3.svg";
export { ForwardRef as ReactComponent };